import {
  getPrimaryAccount,
} from '../../../../utils/sessionUtil';
import { startDate, todayDate } from '../../../../utils/commonUtil';

export const getGrantsApi = () => {
  const MOCK_API_URLS = {
    metaData: [
      {
        method: 'GET', // account details
        url: '/vceptpl/api/grants/account/details',
        page: 'grantsDashboard'
      },
      {
        method: 'GET', // grant count
        url: `/vceptpl/api/grant/count`,
        page: 'grantsDashboard'
      },
      {
        method: 'GET', // current pending grants
        url: `/vceptpl/api/currentPendingGrants`,
        page: 'grantsDashboard'
      },
      {
        method: 'GET', // issued grants
        url: `/vceptpl/api/issuedGrants`,
        page: 'grantsDashboard'
      },
      {
        method: 'GET', // graph
        url: `/vceptpl/api/grant/:accountId/findByAccountIdStartDateAndEndDate`,
        page: 'grantsDashboard'
      },
      {
        method: 'GET', // graph
        url: `/vceptpl/api/grant/all/:accountId/findByAccountIdStartDateAndEndDate`,
        page: 'grantsDashboard'
      }
    ]
  };

  const API_URLS = {
    metaData: [
      {
        // account details
        method: 'GET',
        url: `/donor-portal/api/investment/${
          getPrimaryAccount().userId
        }/findInvestmentSummaryByAccountIdStartDateAndEndDate?startDateStr=${startDate(
          90
        )}&endDateStr=${todayDate()}`,
        page: 'grantsDashboard'
      },
      {
        method: 'GET', // grants count
        url: `/donor-portal/api/grant/${
          getPrimaryAccount().userId
        }/getGrantCountByAccountId`,
        page: 'grantsDashboard'
      },
      {
        // current pending grants
        method: 'GET',
        url: `/donor-portal/api/grant/${
          getPrimaryAccount().userId
        }/getGrantsByAccountIdAndPartyIdAndTypeAndPagination?startDateStr=${startDate(
          90
        )}&endDateStr=${todayDate()}&type=PENDING&page=10`,
        page: 'grantsDashboard'
      },
      {
        // issued grants
        method: 'GET',
        url: `/donor-portal/api/grant/${
          getPrimaryAccount().userId
        }/getGrantsByAccountIdAndPartyIdAndTypeAndPagination?startDateStr=${startDate(
          90
        )}&endDateStr=${todayDate()}&type=ISSUED&page=10`,
        page: 'grantsDashboard'
      },
      {
        // graph
        method: 'GET',
        url: `/donor-portal/api/grant/${
          getPrimaryAccount().userId
        }/findByAccountIdStartDateAndEndDate?startDateStr=${startDate(
          368
        )}&endDateStr=${todayDate()}`,
        page: 'grantsDashboard'
      },
      {
        // graph
        method: 'GET',
        url: `/donor-portal/api/grant/${
          getPrimaryAccount().userId
        }/findByAccountIdStartDateAndEndDate?startDateStr=${startDate(
          1827
        )}&endDateStr=${todayDate()}`,
        page: 'grantsDashboard'
      },
    ]
  };
  if (process.env.REACT_APP_NODE_ENV === 'development') return MOCK_API_URLS;
  return API_URLS;
};
